import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { BusinessEntityService } from 'src/app/services/business-entity.service';
import { OverlayService } from 'src/app/services/overlay.service';
/**
 * The Options used for sorting
 */
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}


@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponentBusinessentity implements OnInit {
  id: string = "";
  addForm: UntypedFormGroup;
  openingHoursForm: UntypedFormGroup;
  contactChannelsForm: UntypedFormGroup;
  files: File[] = [];
  loadingLocation: boolean = false;
  loadedLocation: boolean = false;
  hasLogo: boolean = false;
  currentBusinessEntity: BusinessEntityResource;
  membersToBusinessEntity: BusinessUserResource[]
  newMembersToBusinessEntity: BusinessUserResource[];
  finishedLoading: boolean = false;
  errorContacts: boolean = false;
  errorOpeningHours: boolean = false;
  errorMembers: boolean = false;
  errorData: boolean = false;
  public sortOptions: SortOption[] = [
    { value: 'EVENT_PARTNER', viewValue: 'Aktionspartner' },
    { value: 'SERVICE_CENTER', viewValue: 'Service-Einheit' },
  ];

  public contactChannelOptions: SortOption[] = [
    { value: 'EMAIL', viewValue: 'Mail', state: false },
    { value: 'PHONE_PRIVATE', viewValue: 'Telefon', state: false },
    { value: 'PHONE_MOBILE', viewValue: 'Telefon (Mobil)', state: false },
    { value: 'FAX', viewValue: 'Fax', state: false },
    { value: 'WEBSITE', viewValue: 'Webseite', state: false },
    { value: 'UNKNOWN', viewValue: 'Andere', state: false },
  ];

  public genderOptions: SortOption[] = [
    { value: 'MALE', viewValue: 'Herr' },
    { value: 'FEMALE', viewValue: 'Frau' },
    { value: 'UNDEFINED', viewValue: 'Divers' },
  ]


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private businessEntityService: BusinessEntityService,
    private fb: UntypedFormBuilder,
    private overlayService: OverlayService) {


    this.addForm = this.fb.group({
      publicId: ['', []],
      image: ['', []],
      name: ['', [Validators.required]],
      businessRole: ['EVENT_PARTNER', []],
      description: ['', []],
      state: ['', []],
      address: this.fb.group({
        street: ['', []],
        postcode: ['', []],
        city: ['', []],
        countryCode: ['DE', []],
        location: this.fb.group({
          lat: ['', []],
          lng: ['', []],
        })
      }),
    });

    this.openingHoursForm = this.fb.group({
      openingHours: this.fb.array([])
    })

    this.contactChannelsForm = this.fb.group({
      contactChannels: this.fb.array([])
    })
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      combineLatest([
        this.businessEntityService.getBusinessEntityService(params['id']),
        this.businessEntityService.getMembersToBusinessEntity(params['id'])
      ]).pipe(
        map(([businessEntity, members]: any) => {
          this.currentBusinessEntity = businessEntity;
          if( this.currentBusinessEntity.address != null){
            if(this.currentBusinessEntity.address?.location == null){
              this.currentBusinessEntity.address.location = {
                lng  : "",
                lat : ""
              }
            }
          }
          this.membersToBusinessEntity = members;
          this.addForm.patchValue(businessEntity)
          if (this.currentBusinessEntity?.['links'][1]) {
            this.addForm.patchValue({
              image: businessEntity?.['links'][1]
            })
          }
          this.hasLogo = true;
          if (businessEntity['openingHours']) {
            businessEntity['openingHours'].forEach(element => {
              this.addOpeningHoursWithValue(element)
            });
          }
          if (businessEntity['contactChannels']) {
            businessEntity['contactChannels'].forEach(element => {
              this.addContactChannelsWithValue(element.channelType, element.channelData, element.channelState, element.publicId)
            });
          }

          this.disableType()
        })
      ).subscribe(
        result => {
          this.finishedLoading = true;
        },
        error => {
          console.log("error: ", error);
          this.overlayService.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück")
        }
      );
    })
  }

  disableType() {
    //Disable already active types
    this.getActiveType().forEach(element => {
      this.contactChannelOptions.forEach(type => {
        if (element == type.value) {
          type.state = true;
        }
      })
    });
  }
  onSelect(event) {
    this.files.push(...event.addedFiles);
    this.addForm.controls["image"].setValue(this.files[0])
  }


  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  getPositions() {
    this.loadingLocation = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.showPosition(position)
      });
    } else {
      this.loadingLocation = false;
      //browser does not support geolocation
    }

  }

  showPosition(position) {
    this.loadingLocation = false;
    this.loadedLocation = true;
    this.addForm.controls['address'].patchValue({
      location: {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
    })
  }

  get openingHours() {
    return this.openingHoursForm.controls["openingHours"] as UntypedFormArray;
  }
  addOpeningHours() {
    const openingForm = this.fb.group({
      name: ['', Validators.required],
    });

    this.openingHours.push(openingForm);
  }

  addOpeningHoursWithValue(value) {
    const openingForm = this.fb.group({
      name: [value, Validators.required],
    });

    this.openingHours.push(openingForm);
  }

  deleteOpeningHours(lessonIndex: number) {
    this.overlayService.openDeleteDialog("Wirklich löschen", "Möchten Sie diesen Eintrag wirklich löschen?", "Löschen", "Abbrechen", null, 'openingHours').subscribe(value => {
      if (value) {
        this.openingHours.removeAt(lessonIndex);
      }
    })

    //this.openingHours.removeAt(lessonIndex);
  }

  get contactChannels() {
    return this.contactChannelsForm.controls["contactChannels"] as UntypedFormArray;
  }

  addContactChannelsWithValue(type, data, state, publicId) {
    const contactChannelForm = this.fb.group({
      channelType: [type, Validators.required],
      channelData: [data, Validators.required],
      channelState: [state, Validators.required],
      publicId: [publicId],
    });

    this.contactChannels.push(contactChannelForm);
  }

  addContactChannels() {
    const contactChannelForm = this.fb.group({
      channelType: ['', Validators.required],
      channelData: ['', Validators.required],
      channelState: ['NEW', Validators.required],
    });

    this.contactChannels.push(contactChannelForm);
  }

  deletContactChannels(lessonIndex: number) {
    if (this.contactChannels.value[lessonIndex].publicId) {
      let data = {
        channel: this.contactChannels.value[lessonIndex],
        currentBusinessEntity: this.currentBusinessEntity.publicId
      }
      this.overlayService.openDeleteDialog("Wirklich löschen", "Möchten Sie diesen Eintrag wirklich löschen?", "Löschen", "Abbrechen", data, 'channel').subscribe(value => {
        if (value) {
          this.contactChannels.removeAt(lessonIndex);
        }
      })
    } else {
      this.contactChannels.removeAt(lessonIndex);
    }

    // if(this.contactChannels.value[lessonIndex].publicId){
    //   this.businessEntityService.delteContactChannel(this.currentBusinessEntity.publicId, this.contactChannels.value[lessonIndex]).subscribe(value => {
    //     this.currentBusinessEntity = value;
    //     console.log("DELETE CHANNEL", value)
    //   })
    //   this.contactChannels.removeAt(lessonIndex);
    // }else{
    //   this.contactChannels.removeAt(lessonIndex);
    // }
  }



  toggleLogoUpload() {
    this.hasLogo = !this.hasLogo;
  }

  edit() {
    this.addForm.markAllAsTouched();
    this.openingHoursForm.markAllAsTouched();
    this.contactChannelsForm.markAllAsTouched();

    if (this.addForm.invalid || this.openingHoursForm.invalid || this.contactChannelsForm.invalid) {
      return
    }

    let tempOpening = [];
    this.openingHoursForm.value.openingHours.forEach(element => {
      tempOpening.push(element.name)
    });
    this.currentBusinessEntity.businessRole = this.addForm.value.businessRole;
    this.currentBusinessEntity.name = this.addForm.value.name;
    this.currentBusinessEntity.businessRole = this.addForm.value.businessRole;
    //Update address if it changed
    if (this.currentBusinessEntity.address != null) {
      this.currentBusinessEntity.address.street = this.addForm.value.address.street;
      this.currentBusinessEntity.address.postcode = this.addForm.value.address.postcode;
      this.currentBusinessEntity.address.city = this.addForm.value.address.city;
      this.currentBusinessEntity.address.countryCode = this.addForm.value.address.countryCode;
      this.currentBusinessEntity.address.location.lat = this.addForm.value.address?.location?.lat;
      this.currentBusinessEntity.address.location.lng = this.addForm.value.address?.location?.lng;
    } else {
      let tempAddress = {
        city: null,
        postcode: null,
        street: null,
        countryCode: 'DE',
        location: {
          lat: null,
          lng: null
        }
      }
      this.currentBusinessEntity.address = tempAddress;
      this.currentBusinessEntity.address.street = this.addForm.value.address.street;
      this.currentBusinessEntity.address.postcode = this.addForm.value.address.postcode;
      this.currentBusinessEntity.address.city = this.addForm.value.address.city;
      this.currentBusinessEntity.address.countryCode = this.addForm.value.address.countryCode;

    }


    this.currentBusinessEntity.openingHours = tempOpening;

    this.businessEntityService.updateBusinessEntity(this.currentBusinessEntity).subscribe(value => {
      this.overlayService.openSnackBar("Partner erfolgreich geändert!");
    })

    if (this.files.length != 0) {
      this.businessEntityService.addLogo(this.currentBusinessEntity.publicId, this.files[0]).subscribe(logo => {
      })
    }

    this.contactChannelsForm.value.contactChannels.forEach(element2 => {
      this.businessEntityService.updateContactChannel(this.currentBusinessEntity.publicId, element2).subscribe(value => {
      })
    })
    this.membersToBusinessEntity.forEach(element => {
      this.businessEntityService.updateMember(element).subscribe(value => {
      })
    })

    if (this.newMembersToBusinessEntity != undefined) {
      this.newMembersToBusinessEntity.forEach((element, index) => {
        this.businessEntityService.createAnonMember().subscribe(anon => {
          let tempUser: BusinessUserResource = anon;
          tempUser.person = element.person;
          tempUser.address = element.address;
          tempUser.email = element.email;
          tempUser.phone = element.phone;
          this.businessEntityService.updateAnonMember(tempUser).subscribe(value => {
            this.businessEntityService.addMember(this.currentBusinessEntity.publicId, value).subscribe(valueFromADD => {
              console.log("valueFromADD", valueFromADD)
            })
          })
        })
      });
    } else {
      
    }

  }



  getActiveType() {
    let t = []
    this.currentBusinessEntity.contactChannels.forEach(element1 => {
      t.push(element1.channelType);
    })
    return t;
  }


  changeAvalibleContactChannels(event: MatSelectChange) {
    this.contactChannelOptions.forEach((element) => {
      if (element.value == event.value) {
        element.state = true;
      }
    });
  }

  validateOpeningHoursForm() {
    this.openingHoursForm.markAllAsTouched();
    if (this.openingHoursForm.invalid) {
      this.errorOpeningHours = true;
    } else if (this.openingHoursForm.valid) {
      this.errorOpeningHours = false;
    }
  }

  validateContactChannelsForm() {
    this.contactChannelsForm.markAllAsTouched();
    if (this.contactChannelsForm.invalid) {
      this.errorContacts = true;
    } else if (this.contactChannelsForm.valid) {
      this.errorContacts = false;
    }
  }


  validateAddForm() {
    this.addForm.markAllAsTouched();
    if (this.addForm.invalid) {
      this.errorData = true;
    } else if (this.addForm.valid) {
      this.errorData = false;
    }
  }


}
